module.exports = __webpack_public_path__ + "img/morningglow@2x.a3bd837.jpg";